<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button mode="md" defaultHref="/reports"></ion-back-button>
    </ion-buttons>

    <smr-stylist-picker
      [stylistID]="stylistID"
      [readOnly]="readOnlyStylistPicker"
      [showAllStaff]="true"
      (onInit)="onStylistPickerInit($event)"
      (stylistSelect)="onStylistSelect($event)"
      cssClass="smr-stylist-picker-for-productreport"
    >
    </smr-stylist-picker>
  </ion-toolbar>
  <ion-toolbar>
    <salonmonster-date-picker
      [startDate]="startDate"
      [endDate]="endDate"
      [disabled]="isLoading"
      [groupBy]="groupBy"
      [groupByOptions]="groupByOptions"
      (rangeChanged)="rangeChanged($event)"
    ></salonmonster-date-picker>
  </ion-toolbar>
</ion-header>

<ion-content>
  <salonmonster-load-mask *ngIf="isLoading"></salonmonster-load-mask>

  <salonmonster-tap-retry
    *ngIf="errorOccurredWhileLoadingStylistPicker || errorOccurredWhileLoadingStats"
    (click)="onTapToReload()"
  ></salonmonster-tap-retry>

  <div
    margin-top
    *ngIf="!isLoading && !errorOccurredWhileLoadingStylistPicker && !errorOccurredWhileLoadingStats"
  >
    <ion-row>
      <ion-col size="12" size-lg="12">
        <h2 class="text-align-center">
          <ion-item>
            <ion-label>Top 10 Products Sold by</ion-label>
            <ion-select
              [interface]="'popover'"
              [(ngModel)]="barChartValue"
              (ngModelChange)="onBarChartValueSelected($event)"
            >
              <ion-select-option
                *ngFor="let barChartSelectOption of barChartSelectOptions"
                [value]="barChartSelectOption"
                >{{barChartSelectOption}}</ion-select-option
              >
            </ion-select>
          </ion-item>
        </h2>
        <canvas
          baseChart
          *ngIf="barChartValue == 'Count'"
          [data]="barChartData"
          [options]="barChartOptions"
          [type]="barChartType"
        >
        </canvas>
        <canvas
          baseChart
          *ngIf="barChartValue == 'Price'"
          [data]="barChartPriceData"
          [options]="barChartPriceOptions"
          [type]="barChartType"
        >
        </canvas>
      </ion-col>

    </ion-row>

    <p-table
      styleClass="sticky-table"
      [columns]="cols"
      [value]="stats"
      sortMode="multiple"
      [responsive]="true"
    >
      <ng-template pTemplate="caption">
        <div class="ui-helper-clearfix" style="text-align: right">
          <span class="export">Export to:</span>
          <ion-button
            fill="outline"
            (click)="exportExcel()"
            style="margin-right: 0.5em"
          >Excel</ion-button>
          <ion-button
            fill="outline"
            (click)="exportPdf()"
          >
          PDF
          </ion-button>
        </div>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field">
            <div
              [ngClass]="{'text-align-center': (col.field ==='numSold' || col.field ==='total')}"
            >
              {{col.header}}
              <p-sortIcon [field]="col.field"></p-sortIcon>
            </div>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-stat let-columns="columns">
        <tr>
          <td
            [ngClass]="{'center-numbers-table': (col.field ==='numSold' || col.field ==='total')}"
            *ngFor="let col of columns"
          >
            <!--span class="ui-column-title">{{ col.header }}</!--span-->
            {{col.field === "total" ? (stat[col.field] | salonMonsterCurrency):
            (stat[col.field])}}
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="footer">
        <tr>
          <td><strong>Total</strong></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td class="center-numbers-table">{{ summaryNumSold() }}</td>
          <td class="center-numbers-table">
            {{ summaryTotalSold() | salonMonsterCurrency }}
          </td>
        </tr>
      </ng-template>
    </p-table>
    <!--        <ngx-datatable-->
    <!--          *ngIf="groupBy=='supplier'"-->
    <!--          class="material"-->
    <!--          [rows]="stats"-->
    <!--          [columnMode]="'force'"-->
    <!--          [headerHeight]="50"-->
    <!--          [footerHeight]="50"-->
    <!--          [rowHeight]="50"-->

    <!--          >-->

    <!--          <ngx-datatable-column name="Supplier" prop="supplier" [flexGrow]="1" [summaryTemplate]="templateForTotalText">-->
    <!--            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>-->
    <!--              <span>{{ row.supplier }}</span>-->
    <!--            </ng-template>-->
    <!--          </ngx-datatable-column>-->

    <!--          <ngx-datatable-column name="# Sold" prop="numSold" [flexGrow]="1" [summaryTemplate]="templateForNumSold">-->
    <!--            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>-->
    <!--              <span>{{ row.numSold }}</span>-->
    <!--            </ng-template>-->
    <!--          </ngx-datatable-column>-->

    <!--          <ngx-datatable-column name="$ Sold" prop="total" [flexGrow]="1" [summaryTemplate]="templateForTotalSold">-->
    <!--            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>-->
    <!--              <span>{{ row.total | salonMonsterCurrency }}</span>-->
    <!--            </ng-template>-->
    <!--          </ngx-datatable-column>-->

    <!--        </ngx-datatable>-->
  </div>
</ion-content>
